module.exports = __webpack_public_path__ + "13b932c3d8fd716240a339b0e6865b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/bg/CL054-001.jpg
// module id = 97
// module chunks = 0